import { addAsync as _addAsync, deleteAll as _deleteAll, getAsync as _getAsync, patchAsync as _patchAsync } from "../api";
import { dateToString } from "utils/dateUtils";

let BASE_URL = null;

export function initDB(dbName) {
    BASE_URL = `/modules/${dbName}/attachments`;
}

function normalizeProgressInfoData(data) {
    const { date: dateInMillis } = data;

    const date = new Date(dateInMillis);

    return {
        ...data,
        date,
        dateString: dateToString(date),
    };
}

function normalizeData(data) {
    return data.map((d) => normalizeProgressInfoData(d));
}

export async function getAllByFileCaseIdAsync(personalInfoId) {
    return _getAsync({ url: `${BASE_URL}/filecase/${personalInfoId}`, normalizer: normalizeData });
}

export async function addAsync(payload) {
    return _addAsync({ url: BASE_URL, data: payload });
}

export function deleteAll({ ids, onSuccess, onError }) {
    _deleteAll({ url: BASE_URL, data: { ids }, onSuccess, onError });
}

export async function changeUrlAsync(id, newUrl) {
    return _patchAsync({ url: `${BASE_URL}/${id}:change-url`, data: {newUrl} });
}